export const SET_DASHBOARDS = 'SET_DASHBOARDS'
export const SET_ORDER_DASHBORD_COUNTER = 'SET_ORDER_DASHBORD_COUNTER'
export const SET_OPEN_TICKETS_COUNTER = 'SET_OPEN_TICKETS_COUNTER'
export const SET_FEEDBACKS_COUNTER = 'SET_FEEDBACKS_COUNTER'
